import React from "react";
import Routes from "routing/Routes";
import { ReplaySearchButtonComponent } from "views/components/widgets/ReplaySearchButton";
import usePermissions from "hooks/usePermissions";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
const EventDefinitionReplaySearchLink = ({
  eventDefinitionId = void 0,
  onClick = void 0,
  isMenuitem = false
}) => {
  const { isPermitted } = usePermissions();
  if (eventDefinitionId && !isPermitted(`eventdefinitions:read:${eventDefinitionId}`)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    ReplaySearchButtonComponent,
    {
      searchLink: Routes.ALERTS.DEFINITIONS.replay_search(eventDefinitionId),
      onClick,
      component: isMenuitem ? MenuItem : void 0
    },
    "Replay search"
  );
};
export default EventDefinitionReplaySearchLink;
